export const challengeAcceptedUrl = (id) => `/challenge-accepted/${id}`;
